var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icomoon-ignore"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M78.998 0.271v1023.459h866.004v-725.008l-326.912-298.451h-539.091zM127.109 44.77h457.058v289.238h312.725v645.226h-769.782v-934.464zM866.448 289.51l-234.169-213.8v213.8h234.169zM716.473 430.392c-25.089 0.087-45.48 18.338-45.48 40.847 0.094 22.51 20.391 40.761 45.48 40.761s45.386-18.251 45.48-40.761c0-22.51-20.39-40.761-45.48-40.847zM399.52 498.791c4.699-5.997 12.309-9.299 20.296-9.038 7.329 0.261 14.096 3.651 18.512 9.125l87.014 110.203 51.306-65.27c4.417-5.649 11.464-9.038 19.076-9.213 7.329-0.087 14.376 2.955 18.981 8.257l156.55 177.645c5.732 6.606 6.953 15.644 3.101 23.379-3.947 7.735-12.217 12.776-21.425 12.863l-158.523 1.825h-355.008c-9.115 0-17.385-4.693-21.519-12.255-4.041-7.474-3.195-16.425 2.161-23.205l179.478-224.316zM418.784 549.546l87.296 110.638c0.056 0.102 0.111 0.174 0.166 0.234 0.039 0.042 0.077 0.078 0.117 0.113l42.286 53.537h-261.512l131.648-164.522zM702.471 712.852l-105.337-119.502-41.909 53.537 52.997 67.095 94.249-1.129z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageFile);
export default __webpack_public_path__ + "static/media/image-file.2a4c198daaca1cbf1da7cb7cc01d21da.svg";
export { ForwardRef as ReactComponent };